const pages: Record<string, string> = {
  // Quote form
  'form.title': '申请报价',
  'form.intro': '告诉我们您销售的产品和目标市场。我们将确认适用的认证，并回复服务范围和报价。',
  'form.name': '您的姓名',
  'form.company': '公司',
  'form.email': '工作邮箱',
  'form.service': '您需要什么服务？',
  'form.opt.0': '无线电 / 无线（Wi-Fi、蓝牙等）',
  'form.opt.1': 'EMC（电磁兼容）',
  'form.opt.2': '安全认证标志',
  'form.opt.3': '以上多项',
  'form.opt.4': '暂不确定',
  'form.markets': '您希望销售的国家',
  'form.marketsPlaceholder': '例如：墨西哥、巴西、南非',
  'form.product': '产品和型号（选填）',
  'form.productPlaceholder': '例如：Wi-Fi 6 路由器，型号 X100，2.4 GHz 和 5 GHz',
  'form.error': '无法发送您的请求。请重试，或直接发送电子邮件',
  'form.errorAt': '至 {{email}}',
  'form.errorEnd': '。',
  'form.send': '提交申请',
  'form.sending': '发送中...',
  'form.thanksTitle': '感谢您，我们已收到您的申请',
  'form.thanksText': '我们将审核您列出的产品和市场，并通过电子邮件回复。',

  // Countries
  'countries.title': '我们覆盖的国家',
  'countries.intro': '无线电、EMC 和安全认证，由我们在各市场的本地合作伙伴协助办理。选择国家，查看当地要求。',
  'countries.notListed': '要销售的国家不在列表中？请在下方告诉我们，我们会为您确认。',
  'country.notFound': '未找到该国家',
  'country.seeAll': '查看我们覆盖的国家',
  'country.breadcrumb': '国家',
  'country.authority': '监管机构：',
  'country.verified': '最后核实日期：{{date}}。',
  'country.partner': '合作伙伴：',
  'country.keyPoints': '您需要了解的要点',
  'country.note': '法规要求会发生变化，且因产品而异。我们会在报价前为您的产品确认最新规定。',
  'country.process': '我们的办理流程',
  'country.quoteTitle': '要在{{name}}销售？获取报价',

  // News
  'news.title': '法规动态',
  'news.intro': '我们所覆盖市场的认证规则变化，及其对您产品的影响。',
  'news.empty': '暂无动态。请使用下方表格，市场出现变化时我们会通知您。',
  'news.whatToDo': '建议措施：',
  'news.source': '查看监管机构公告',
  'news.formTitle': '这项动态是否影响您的产品？',
  'news.formIntro': '告诉我们产品型号和目标国家，我们将免费告知适用的要求。',
};
export default pages;
